<template>
  <div class="sub-form-custom-object">
    <template v-if="doRender">
      <BaseSelect
        v-if="customObjects.length"
        v-model="form.groupID"
        :options="customObjects"
        valueKey="id"
        labelKey="name"
        label="Custom object"
        name="custom object"
        placeholder="Select custom object..."
        validate="required"
      ></BaseSelect>

      <TypographyInputError v-else>You haven't any custom objects yet.</TypographyInputError>
    </template>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        doRender: false,
        form: {
          groupID: ''
        }
      }
    },
    computed: {
      ...mapGetters('shopCustomobjectsgroupsList', {
        customObjects: 'customObjectsGroupsMapped'
      })
    },
    async created () {
      if (!this.customObjects.length) {
        await this.$store.dispatch('shopCustomobjectsgroupsList/GET_CUSTOM_OBJECTS_GROUPS')
      }
      this.doRender = true
      this.$emit('update')
    },
  }
</script>

<style lang="scss">
.sub-form-custom-object {
}
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormCustomObject.vue